<template>
    <div>
        <!-- 注：添加操作时，当左边没有树的值传入时，添加需要默认清空内容defaultEmpty，但包含树图或有内容传入时需要去掉该属性 -->
        <base-form-plus :isAdd="formInfo.isAdd" :relationDialogVisible.sync="formInfo.dialogVisible" showTitle="代码模板表"
                  :showData="formInfo.editData"
                  :rules="rules" @submitAdd="submitAdd" @submitEdit="submitEdit" ref="baseForm" defaultEmpty>
            <!-- 插槽部分 -->
            <template v-slot:default="{ruleForm}" class="info">
                        <!-- 所属模板包ID -->
                        <el-form-item :label="columnInfo.packageId.label" prop="packageId">
                                <options-select v-model="ruleForm.packageId" :options="options.packageIdOptions" :props="options.props"></options-select>
                        </el-form-item>
                        <!-- 模板类型 -->
                        <el-form-item :label="columnInfo.templateType.label" prop="templateType">
                                <el-input v-model="ruleForm.templateType" placeholder="请输入内容"  clearable></el-input>
                        </el-form-item>
                        <!-- 模板名称 -->
                        <el-form-item :label="columnInfo.templateName.label" prop="templateName">
                                <el-input v-model="ruleForm.templateName" placeholder="请输入内容"  clearable></el-input>
                        </el-form-item>
                        <!-- 文件名占位符 -->
                        <el-form-item :label="columnInfo.fileNamePlaceholder.label" prop="fileNamePlaceholder">
                                <el-input v-model="ruleForm.fileNamePlaceholder" placeholder="请输入内容"  clearable></el-input>
                        </el-form-item>
                        <!-- 模板文件存储路径 -->
                        <el-form-item :label="columnInfo.templateFilePath.label" prop="templateFilePath">
                                <el-input v-model="ruleForm.templateFilePath" placeholder="请输入内容"  clearable></el-input>
                        </el-form-item>
                        <!-- 模板内容 -->
                        <el-form-item :label="columnInfo.templateContent.label" prop="templateContent">
                                <el-input v-model="ruleForm.templateContent" placeholder="请输入内容"  clearable></el-input>
                        </el-form-item>
                        <!-- 描述 -->
                        <el-form-item :label="columnInfo.description.label" prop="description">
                                <el-input v-model="ruleForm.description" placeholder="请输入内容"  clearable></el-input>
                        </el-form-item>
                        <!-- 状态 -->
                        <el-form-item :label="columnInfo.state.label" prop="state">
                                <enum-dict-select v-model="ruleForm.state" module-name="data" dict-code="state"></enum-dict-select>
                        </el-form-item>
            </template>
        </base-form-plus>
    </div>
</template>

<script>
    /**
     * 	代码模板表表单
     * 	@author PeterLee
     * 	@since 2026-01-31
     */
    import {mapState, mapMutations, mapActions} from "vuex";

    export default {
        name: 'codeTemplateForm',
        // 计算操作
        computed: {
            ...mapState({
                // 校验规则
                rules: state => state.data.codeTemplate.rules,
                // 表格数据
                tableData: state => state.data.codeTemplate.tableData,
                // 表单信息
                formInfo: state => state.data.codeTemplate.formInfo,
                // 下拉选项
                options: state => state.data.codeTemplate.options,
                // 列信息
                columnInfo: state => state.data.codeTemplate.columnInfo,
            })
        },
        methods: {
            ...mapMutations({
                setDialogVisible: 'data/codeTemplate/setDialogVisible',
            }),
            ...mapActions({
                submitAdd: 'data/codeTemplate/submitAdd',
                submitEdit: 'data/codeTemplate/submitEdit',
            })
        }
    }
</script>

<style lang="less" scoped>
    .info {
        display: flex;
        flex-wrap: wrap;

        .el-form-item {
            width: 50%;
        }
    }
</style>
